// import React, { createContext, useContext, useState, useEffect } from "react";

// const AuthContext = createContext(null);

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);

//   // לטעון משתמש ששמור ב-localStorage (אם יש)
//   useEffect(() => {
//     const saved = localStorage.getItem("app_user");
//     if (saved) {
//       setUser(JSON.parse(saved));
//     }
//   }, []);

//   const login = (userData) => {
//     setUser(userData);
//     localStorage.setItem("app_user", JSON.stringify(userData));
//   };

//   const logout = () => {
//     setUser(null);
//     localStorage.removeItem("app_user");
//   };

//   return (
//     <AuthContext.Provider value={{ user, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);






import React, { createContext, useContext, useState, useEffect } from "react";
import { base44 } from "@/api/base44Client";
import { normalizeUserRecord } from "@/lib/userDisplayName";
import {
  readAuthToken,
  readStoredUser,
  sanitizeCorruptedAuthKeys,
  clearAuthStorage,
  writeAuthToken,
} from "@/lib/authStorage";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const refreshMe = async () => {
    const token = readAuthToken();
    if (!token) return null;
  
    const freshUser = await base44.auth.me();
    if (freshUser) {
      const merged = normalizeUserRecord(freshUser);
      setUser(merged);
      localStorage.setItem("app_user", JSON.stringify(merged));
    }
    return freshUser;
  };
  
  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      sanitizeCorruptedAuthKeys();
      const token = readAuthToken();
      const parsedUser = readStoredUser();

      if (parsedUser) {
        setUser(normalizeUserRecord(parsedUser));
      }

      if (!token) {
        if (!cancelled) setLoading(false);
        return;
      }

      // ── במצב התחזות — לא קוראים ל-/me כדי לא לדרוס את נתוני החנות ──────────
      if (parsedUser?.is_impersonating) {
        if (!cancelled) setLoading(false);
        return;
      }
      // ─────────────────────────────────────────────────────────────────────────

      try {
        const freshUser = await base44.auth.me();
        if (cancelled) return;
        if (freshUser) {
          const merged = normalizeUserRecord(freshUser);
          setUser(merged);
          localStorage.setItem("app_user", JSON.stringify(merged));
        }
      } catch (err) {
        if (cancelled) return;
        if (err?.response?.status === 401) {
          setUser(null);
          clearAuthStorage();
          if (typeof navigator !== "undefined" && navigator.onLine) {
            window.location.href = "/login";
          }
        }
        // שגיאת רשת / 5xx — נשארים עם מה שנטען מ-localStorage (אם יש)
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, []);
  

  const login = (userData, token) => {
    writeAuthToken(token);

    const merged = normalizeUserRecord(userData);
    setUser(merged);
    localStorage.setItem("app_user", JSON.stringify(merged));
    
    // ביטול מצב הטעינה כדי לאפשר לאפליקציה לרנדר את הדפים המוגנים
    setLoading(false); 
  };
  

  // --- הפונקציה שמתקנת את כפתור ההתנתקות ---
  const logout = () => {
    console.log("🔒 Logging out...");
    setUser(null);
    clearAuthStorage();
    if (typeof navigator !== "undefined" && navigator.onLine) {
      window.location.href = "/login"; // רענון מלא ומעבר לדף התחברות רק כשיש רשת
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refreshMe, loading, isAuthenticated: !!user }}>
      {/* הוספת מעטפת יציבה עם מפתח קבוע מונעת מ-React לאבד את המיקום ב-DOM */}
      <div key="app-auth-wrapper">
        {!loading ? (
          children
        ) : (
          <div key="auth-loading-spinner" className="flex items-center justify-center min-h-screen">
            {/* כאן תוכל לשים ספינר טעינה אם תרצה */}
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-500"></div>
          </div>
        )}
      </div>
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};